<template>
  <!--安防 试听视频更多页面-->
  <section class="container">
    <Header></Header>
    <div class="wrapper">
      <div class="locationM text-left">
        <Breadcrumb>
          <img class="img" src="../assets/location.png" alt="">
          当前位置：
          <BreadcrumbItem to="/">首页</BreadcrumbItem>
          <BreadcrumbItem>{{auditionTypeName}}</BreadcrumbItem>
        </Breadcrumb>
      </div>
      <div class="innerM">
        <div class="inner-wrapper">
            <div class="title2">
              {{auditionTypeName}}
            </div>
            <div class="courseM">
              <div class="col-20 course" v-for="(audition, index) in auditionList"  :key="index" @click="auditionClick"  :data-id="audition.auditionId">
                <div class="cover inner pointer text-center">
                  <img :src="audition.cover" alt="">
                </div>
                <div class="name text-left overflow inner pointer">
                  {{audition.title}}
                </div>
              </div>
            </div>
        </div>
        <div class="pageM">
            <Page v-if="auditionList.length > 0"  :total="auditionTotal" :current.sync="auditionPage" @on-change="pageClick"/>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </section>
</template>

<script>
  import Header from './components/Header'
  import Footer from './components/Footer'
  export default {
    name: "AuditionList",
    data(){
      return {
        auditionTypeName: '', //试听课程类型名称
        auditionType : '', //试听课程类型名称
        auditionTotal: 0,  //试听课程总条数--默认为0
        auditionPage: 1,  //试听课程总条数
        auditionList: [] //试听课程列表
      }
    },
    mounted(){
      this.onload();
      this.setTab();
    },
    methods: {
      onload(){
        //加载初始化
        var that = this;
        that.$store.state.tab = 0;
        that.auditionType =  that.$route.params.auditionType;
        if(that.auditionType == 1){
          that.auditionTypeName = '系统集成专业课程试听';
        }else {
          that.auditionTypeName = '系统集成继续教育课程试听';
        }
        this.getList();
      },
      getList(){
        //试听课程列表接口
        var that = this;
        var modelData = {
          "auditionType": that.$route.params.auditionType,
          "page": +that.auditionPage,
          "size": "10"
        };
        this.$http({
          url: that.webhost + 'audition/list',
          method: 'POST',
          data: modelData
        }).then(({data}) => {
          if (data && data.code === 0) {
            that.auditionList = data.data.list;
            that.auditionTotal = data.data.totalCount;
          } else {
            that.$toast.error(data.msg)
          }
        })
      },
      auditionClick(e){
        var that = this;
        that.$router.push('/Audition/'+that.auditionType+'/'+e.currentTarget.dataset.id);
      },
      pageClick(){
        //翻页事件
        this.getList();
      }
    },
    components: {
      Header,
      Footer
    }
  }
</script>

<style scoped>
  .wrapper{
    width: 1200px;
    min-width: 1200px;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 70px;
    font-family: "PingFang SC";
  }
  .title{
    text-align: left;
    font-size: 25px;
    line-height: 72px;
    color: #000;
    border-bottom: solid 2px #ccc;
  }
  .title2{
    text-align: left;
    font-size: 21px;
    line-height: 70px;
    color: #000;
  }
  .locationM{
    height: 50px;
    line-height: 50px;
  }
  .locationM .ivu-breadcrumb{
    font-size: 15px;
    color: #000;
  }
  .locationM img{
    width: 23px;
    height: 22px;
    margin-right: 5px;
    position: relative;
    top: 3px;
  }
  .innerM{
    margin-top: 20px;
  }
  .courseM{
    width: 100%;
    text-align: left;
  }
  .course{
    display: inline-block;
    width: 20%;
    margin-bottom: 25px;
    padding-top: 7px;
  }
  .course:hover {
    border-color: #ddd;
    box-shadow: 1px 1px 2px 1px #ddd;
  }
  .course .inner{
    width: 95%;
    margin: auto;
  }
  .course .cover img{
    width: 224px;
    height: 128px;
  }
  .course .btn{
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }
  .course .name{
    font-size: 15px;
    color: #000;
    padding: 5px 0 5px 2px;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/AuditionList.vue